import { property } from 'lit/decorators.js';
import { trustedCSS } from '../../lib/css/css.js';
import { CrntButton } from '../button/button.component.js';
import iconButtonStyles from './icon-button.css.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntIconButton extends CrntButton {
  constructor() {
    super();
    this.state = "enabled";
    this.iconOnly = true;
  }
  static {
    /** @internal */
    this.styles = [...CrntButton.styles, trustedCSS(iconButtonStyles)];
  }
  static {
    /** @internal */
    this.tagName = "crnt-icon-button";
  }
}
__decorateClass([
  property({ reflect: true })
], CrntIconButton.prototype, "state");

export { CrntIconButton };
